import React, { useState, useCallback, useEffect } from 'react';
import { Chart, Series, Legend, ValueAxis,
  Aggregation, AggregationInterval, ArgumentAxis, Tooltip,
  Label, TickInterval, CommonSeriesSettings, } from 'devextreme-react/chart';
import { groupBy } from '../../utils/miscUtil';

export default function SIFReportingCompanies(props) {
  const [accState, setAccState] = useState(false);
  const [total, setTotal] = useState(0);

  const calculateCCount = useCallback((aggregationInfo) => {
    if (!aggregationInfo.data.length) {
      return null;
    }
    let fd = groupBy(aggregationInfo.data, 'company_id')
    return {
      'DATE OF EVENT (m/d/yyyy)': aggregationInfo.intervalStart,
      value: Object.keys(fd).length,
    };
  }, []);

  function customizeText(arg) {
    let q = Math.floor((arg.value.getMonth() + 3) / 3).toString();
    let y = arg.value.getFullYear().toString();
    return `Qtr ${q} ${y}`;
  }

  const customizeTooltip = (pointInfo) => {
    let q = Math.floor((pointInfo.argument.getMonth() + 3) / 3).toString();
    let y = pointInfo.argument.getFullYear().toString();
    return {
      html: `<div><div class="tooltip-header">${`Qtr ${q} ${y}`}</div><div class="tooltip-body">${pointInfo.points[0]?.seriesName}: ${pointInfo.points[0].valueText}</div></div>`,
    }
  };

  const onAccClick = useCallback(() => {
    setAccState(!accState);
  }, [accState]);

  useEffect(() => {
    if (props.data) {
      let fd = groupBy(props.data, 'company_id')
      setTotal(Object.keys(fd).length)
    }
  }, [props.data]);


  return (
      <div className="accordion my-2">
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={accState?"py-1 accordion-button":"py-1 accordion-button collapsed"}
              onClick={onAccClick}
              type="button">
              Reporting Companies ({total})
            </button>
          </h2>
          <div className={accState?"accordion-collapse collapse show":"accordion-collapse collapse"}>
            <div className="accordion-body">
            <Chart
              id="chart"
              dataSource={props.data}
            >
              <ArgumentAxis aggregatedPointsPosition="crossTicks">
                <AggregationInterval quarters={1} />
                <TickInterval quarters={1} />
                <Label customizeText={customizeText}
                />
              </ArgumentAxis>
              <CommonSeriesSettings
                argumentField="DATE OF EVENT (m/d/yyyy)"
                type="stackedbar"
              >
                <Aggregation
                  enabled={true}
                  calculate={calculateCCount}
                  method="custom"
                />
              </CommonSeriesSettings>
              <Series
                valueField="value"
                color="#5dc3d7"
                name="Companies"
                customizeTooltip={customizeTooltip}
              >
              </Series>
              <ValueAxis showZero={true} />
              <Legend visible={false} />
              <Tooltip
                enabled={true}
                shared={true}
                customizeTooltip={customizeTooltip}
              />
            </Chart>
            </div>
          </div>
        </div>
      </div>
  );
}
